function getResponseIds(value) {
    return value?.map?.((v) => v.id || v) || value?.id || value;
}

export default getResponseIds;
